import { Injectable } from '@angular/core';
import { endpoint } from '@tekman/onmat/constants';
import { Course, StepBlock, StepsCategoryModel, StepsExtraBlock } from '@tekman/onmat/models';
import { ApiService } from '@tekman/onmat/service/generic';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CoursesService {
  constructor(private readonly apiService: ApiService) {}

  getCourses(): Observable<Course[]> {
    return this.apiService.get<Course[]>(endpoint.courses.retrieve);
  }

  getCourseSteps(courseId: string, groupId: string): Observable<StepBlock[]> {
    return this.apiService.get<StepBlock[]>(
      this.apiService.replaceUrl(this.apiService.replaceUrl(endpoint.courses.blocks, '{groupId}', groupId), '{courseId}', courseId)
    );
  }

  getStepsByGroup(stepId: string, groupId: string): Observable<StepsCategoryModel> {
    return this.apiService.get<StepsCategoryModel>(
      this.apiService.replaceUrl(this.apiService.replaceUrl(endpoint.courses.steps, '{stepId}', stepId), '{groupId}', groupId)
    );
  }

  getStepsByExtraBlock(blockId: string, courseId: string, groupId: string): Observable<StepsExtraBlock[]> {
    const url = this.apiService.replaceUrl(
      this.apiService.replaceUrl(this.apiService.replaceUrl(endpoint.courses.stepsExtra, '{id}', blockId), '{id}', courseId),
      '{id}',
      groupId
    );
    return this.apiService.get<StepsExtraBlock[]>(url);
  }
}
